import _ from 'lodash'
import { i18n } from '../locales'
import $store from '../store'

const TRESHOLD_MIL = 1000000,
  TRESHOLD_BIL = 1000000000,
  TRESHOLD_TRL = 1000000000000

// functions

const financial = (value, digits) => {
  const d = _.isNumber(digits) ? digits : $store.state.market.digitsAfterDot
  if (_.isUndefined(value)) return ''
  return _.isNumber(Number(value)) ? Number(value).toFixed(d) : String(value)
}

const percentWithPlus = (value) => {
  if (!_.isNumber(value)) return ''
  if (_.isNaN(value)) value = 0
  return `${value > 0 ? '+' : ''}${value}%`
}

const getCap = (val, currency = undefined) => {
  if (_.isUndefined(val) || !_.isNumber(val)) {
    if (_.isString(val)) return val
    return ''
  }

  const _currency =
    (currency === undefined ? $store.state.market.currency : currency) || 'RUB'

  const i18nCurrency =
    'numbers.currencies.' + (_currency == 'GBX' ? 'GBP' : _currency)

  if (_currency == 'GBX') val = val / 100

  const getFullText = (t) => {
    return i18n.t(i18nCurrency, [t])
  }

  if (val > TRESHOLD_BIL) {
    if (val > TRESHOLD_TRL) {
      return getFullText(
        i18n.t('numbers.currencyTRL', [(val / TRESHOLD_TRL).toFixed(2)])
      )
    }
    return getFullText(
      i18n.t('numbers.currencyBIL', [(val / TRESHOLD_BIL).toFixed(2)])
    )
  }
  return getFullText(
    i18n.t('numbers.currencyMIL', [(val / TRESHOLD_MIL).toFixed(2)])
  )
}

const shortText = require('./filters/shortText')

export default {
  financial,
  percentWithPlus,
  getCap,
  shortText,
}

export { financial, percentWithPlus, getCap, shortText }
